import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'
import type { Recruiter } from '@/types/recruiter'

export const useRecruitersStore = defineStore('recruiters', () => {
  const isLoading = ref(false)
  const recruiters = ref<Recruiter[]>([])
  const error = ref<string | null>(null)

  async function fetchRecruiters() {
    isLoading.value = true
    error.value = null
    
    try {
      const response = await api.get(API_ROUTES.GET_RECRUITERS)
      recruiters.value = response.data
    } catch (err) {
      error.value = 'Failed to fetch recruiters'
      console.error('Error fetching recruiters:', err)
    } finally {
      isLoading.value = false
    }
  }

  return {
    isLoading,
    recruiters,
    error,
    fetchRecruiters
  }
})
